import { module } from 'modujs';
import gsap from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
        this.totalMedias = this.el.querySelectorAll('.c-menu_media').length;
        this.mediaHeight = this.el.querySelector('.c-menu_media').offsetHeight;
        this.mediasHeight = this.el.querySelector('.c-menu_medias_inner').offsetHeight;

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    init() {
        document.querySelectorAll('.c-menu_open').forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                this.el.classList.add('-visible');
                this.call('stop', 'Scroll');
            });
        });

        let active = this.el.querySelector('.c-menu_nav_item.-active');
        if (active) {
            let index = active.dataset.index;
            gsap.to(this.el.querySelector('.c-menu_medias_inner'), {
                y: (-index / this.totalMedias * this.mediasHeight) + ((window.innerHeight / 2) - (this.mediaHeight / 2)) + 'px',
                duration: 0.8,
                ease: 'power4.out'
            });
        }

        this.el.querySelectorAll('.c-menu_nav_item').forEach((item) => {
            item.addEventListener('mouseenter', () => {
                this.mediaHeight = this.el.querySelector('.c-menu_media').offsetHeight;
                this.mediasHeight = this.el.querySelector('.c-menu_medias_inner').offsetHeight;
                
                let index = item.dataset.index;
                this.el.querySelectorAll('.c-menu_media').forEach((media) => {
                    media.classList.remove('-active');
                });
                this.el.querySelector('.c-menu_media[data-index="' + index + '"]').classList.add('-active');

                gsap.to(this.el.querySelector('.c-menu_medias_inner'), {
                    y: (-index / this.totalMedias * this.mediasHeight) + ((window.innerHeight / 2) - (this.mediaHeight / 2)) + 'px',
                    duration: 0.8,
                    ease: 'power4.out'
                });
            });
        });
    }

    close() {
        this.el.classList.remove('-visible');
        this.call('start', 'Scroll');
    }
}
